import { ENV } from 'utils/constants';

const getApiURL = () => {
  if (typeof window === 'undefined' && ENV.apiServiceUrl) {
    return ENV.apiServiceUrl;
  }

  return ENV.baseUrl;
};
export default getApiURL;
